<template>
  <div class="countBox">
    <!-- ModernUI-Section-Start -->
    <section class="row_am modern_ui_section">
      <!-- container start -->
      <div class="container">
        <!-- row start -->
        <div class="row">
          <div class="col-lg-6">
            <!-- UI content -->
            <div class="ui_text">
              <div
                class="section_title"
                data-aos="fade-up"
                data-aos-duration="1500"
                data-aos-delay="100"
              >
                <h2>Beautiful Design  <span>with a Modern UI</span></h2>
                <p>
                  Salt is carefully designed to be fast, intuitive, and visually clean—so booking or managing clients feels effortless.
                </p>
              </div>
              <ul class="design_block">
                <li data-aos="fade-up" data-aos-duration="1500">
                  <h4>Carefully Designed</h4>
                  <p>
                    Every screen is crafted to keep things simple, clear, and user-friendly.
                  </p>
                </li>
                <li data-aos="fade-up" data-aos-duration="1500">
                  <h4>Seamless Sync</h4>
                  <p>
                    Appointments, chats, and payments stay perfectly synced across devices.
                  </p>
                </li>
                <li data-aos="fade-up" data-aos-duration="1500">
                  <h4>Access Anywhere</h4>
                  <p>
                    Manage bookings and conversations anytime, anywhere.
                  </p>
                </li>
              </ul>
            </div>
          </div>
          <div class="col-lg-6">
            <!-- UI Image -->
            <div class="ui_images" data-aos="fade-in" data-aos-duration="1500">
              <div class="left_img">
                <img
                  class="moving_position_animatin"
                  src="images/modern001.png"
                  alt="image"
                />
              </div>
              <!-- UI Image -->
              <div class="right_img">
                <img
                  class="moving_position_animatin"
                  src="images/secure_data03.png"
                  alt="image"
                />
                <img
                  class="moving_position_animatin"
                  src="images/modern002.png"
                  alt="image"
                />
                <img
                  class="moving_position_animatin"
                  src="images/modern003.png"
                  alt="image"
                />
              </div>
            </div>
          </div>
        </div>
        <!-- row end -->
      </div>
      <!-- container end -->
    </section>
    <!-- ModernUI-Section-end -->
  </div>
</template>

<script>
export default {
  name: "CountBox",
};
</script>
